import { defineComponent as _defineComponent } from 'vue'
import { Heading, Grid, CategoryCard } from '@warrenbrasil/nebraska-web';
import {
  CategoryCardMain,
  CategoryCardFooter,
  CategoryCardProfitabilityMain,
  CategoryCardProfitabilityFooter
} from './components';
import { useRoute, useRouter } from 'vue-router/composables';
import { EProductType, IProduct } from '@/modules/products/services/products';

interface Props {
  loading: boolean;
  cards: IProduct[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductsViewContent',
  props: {
    loading: { type: Boolean },
    cards: null
  },
  setup(__props: any) {


const router = useRouter();
const route = useRoute();

function goToCatalog(tab: EProductType) {
  if (tab === EProductType.Pension) {
    window.open('https://lp.warren.com.br/previdencia');
    return;
  }

  router.push({
    name: 'productsCatalog',
    params: {
      type: tab || 'fixed-income'
    }
  });
}

function goToCategory(productType: EProductType) {
  window.location.assign(`/products/#/categories/${productType}`);
}

function goToPortfolioCatalog() {
  const currentModule = route.name;

  router.push({ name: 'catalog', query: { module: currentModule } });
}

function handleRedirect({ action, productType }: IProduct) {
  const redirectMapper: { [key: string]: () => void } = {
    OPEN_CATALOG: () => goToCatalog(productType),
    OPEN_DETAILS: () => goToCategory(productType),
    OPEN_PORTFOLIO_CATALOG: () => goToPortfolioCatalog()
  };

  redirectMapper[action]();
}

return { __sfc: true,router, route, goToCatalog, goToCategory, goToPortfolioCatalog, handleRedirect, Heading, Grid, CategoryCard, CategoryCardMain, CategoryCardFooter, CategoryCardProfitabilityMain, CategoryCardProfitabilityFooter }
}

})